
import { supabase } from "@/integrations/supabase/client";
import { Tables } from "@/integrations/supabase/types";
import { fetchAllSuggestionsRaw } from "./rawFetch";

/**
 * Fetches suggestions directly from the database using the simplest possible approach
 * This is a fallback method when other approaches fail
 * @param setSuggestions - State setter function for suggestions
 * @returns Promise that resolves when the operation is complete
 */
export const fetchSuggestionsSimple = async (
  setSuggestions: (suggestions: Tables<'suggestions'>[]) => void
): Promise<void> => {
  try {
    console.log('Performing simple fetch of suggestions...');
    
    // Using the most basic query possible to rule out any query issues
    const { data, error } = await supabase
      .from('suggestions')
      .select();
    
    if (error) {
      console.error('Simple fetch error:', error);
      await fetchAllSuggestionsRaw(setSuggestions);
      return;
    }
    
    console.log('Simple fetch results:', data);
    
    if (Array.isArray(data) && data.length > 0) {
      console.log(`Simple fetch found ${data.length} results`);
      setSuggestions(data);
    } else {
      console.log('Simple fetch found no results, trying RPC method...');
      await fetchAllSuggestionsRaw(setSuggestions);
    }
  } catch (error) {
    console.error('Error in simple fetch:', error);
    await fetchAllSuggestionsRaw(setSuggestions);
  }
};
